import * as jwt from 'jsonwebtoken';
import BaseService from '../base.service';
import store from '@/store';

const conceptService = class ConceptService extends BaseService {
  // eslint-disable-next-line no-useless-constructor
  constructor () {
    super();
  }

  all (page: 1) {
    const url = this.baseURL + '';

    return super.get(url, {
      page: page,
    });
  }

  checkOnboarding () {
    const url = this.baseURL + 'onboarding';
    return super.get(url);
  }

  getTerms () {
    const url = this.baseURL + 'user-terms?filter[term-key]=solo-toc-20230205';
    return super.get(url);
  }

  get () {
    const { key } = store.getters['account/activeConcept'];
    const url = `${this.baseURL}concepts/${key}`;
    return super.get(url);
  }

  updateConcept (payload: any, conceptId: any) {
    const url = this.baseURL + `concepts/${conceptId}`;

    return super.patch(url, payload);
  }

  applyUpdatesToLocations (payload: any = {}) {
    const url = this.baseURL + `concepts/${store.getters['account/activeConcept'].id}/copy-default-delivery-settings-to-locations`;

    return super.post(url, payload);
  }

  applyOpeningHours (payload: any = {}) {
    const url = this.baseURL + `concepts/${store.getters['account/activeConcept'].id}/copy-default-opening-hours-to-locations`;

    return super.post(url, payload);
  }

  find () {
    this.conceptId = store.getters['account/activeConcept'].id;
    const url = this.baseURL + 'concepts/' + this.conceptId + '/applications';

    return super.get(url);
  }

  default () {
    const { key } = store.getters['account/activeConcept'];
    const url = `${this.baseURL}concepts/${key}`;
    return super.get(url);
  }

  settings () {
    this.conceptId = store.getters['account/activeConcept'].id;
    const url = this.baseURL + 'concepts/' + this.conceptId + '/settings';

    return super.get(url);
  }

  getTapPublicKey () {
    const url = this.baseURL + 'integration-options/tap/web_public_key';
    return super.get(url);
  }

  getCheckoutPublicKey () {
    const url = this.baseURL + 'integration-options/checkout/public_key';
    return super.get(url);
  }

  getMetabaseReport (dashboard: 5) {
    // NOTE: Dashboard IDs: 5-General, 6-Customers, 7-Locations, 8-Orders, 11-Products
    const payload = {
      resource: { dashboard },
      params: {
        id: [store.getters['account/activeConcept'].id],
      },
      exp: Math.round(Date.now() / 1000) + (10 * 60), // 10 minute expiration
    };
    const token = jwt.sign(payload, process.env.VUE_APP_METABASE_SECRET_KEY);

    return process.env.VUE_APP_METABASE_SITE_URL + '/embed/dashboard/' + token + '#bordered=true&titled=true';
  }
};

export default conceptService;
